import AuthorizationService from "../service/authorization-service";
import menu from "../config/menu";

const authorizationService = new AuthorizationService();

function Dashboard() {
    const availableMenu = menu.map((menuGroup) => {
        return {
            title: menuGroup.title,
            items: menuGroup.items.map(menuItem => authorizationService.can(menuItem.section) ? menuItem : null).filter(value => value !== null)
        };
    });
        
    return (
        <div className="container pt-3">
            {availableMenu.map((group, index) => {
                if(group.items.length === 0) return '';

                return (
                <div key={`group-${index+1}`}>
                    <h4 className="fs-6 mt-3 mb-2"><i className="bi bi-stop-fill align-text-bottom me-1"></i>{group.title}</h4>
                    <div className="row">
                        {group.items.map((item, index) => {
                            return (
                                <div key={`item-${index+1}`} className="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
                                    <div className="card">
                                        <div className="row g-0">
                                            <div className="col-auto">
                                                <div className="mx-3 me-0 h-100 d-flex align-items-center">
                                                    <span className="bg-light text-secondary rounded fs-4 lh-1 p-2">
                                                        <i className={`bi ${item.icon}`}></i>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="card-body">
                                                    <h5 className="card-title fs-6 mb-3">
                                                        <a className="text-decoration-none text-reset stretched-link fw-bold" href={item.url} >{item.title}</a>
                                                    </h5>
                                                    <h6 className="card-subtitle text-secondary" style={{fontSize: "0.9rem"}}>{item.description}</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>);
            })}
        </div>
    );
}

export default Dashboard;